/*
  Роуты, которые живут вне общего оформления: вход, админка и портальная
  страница. Для темы это «всегда светлые» экраны, для аналитики — страницы,
  где она не поднимается.

  Список лежит отдельным модулем, потому что им пользуются и ThemeProvider,
  и src/analytics: если держать его в ThemeProvider, получается кольцевой
  импорт (аналитика тянет список, тема тянет track).
*/
export const LIGHT_ONLY = [/^\/login$/, /^\/admin/i, /^\/notNetwork$/];

export default LIGHT_ONLY;
